module.exports = __webpack_public_path__ + "media/images/twitter_black-e6bb2927.svg";